// pages/Dashboard.jsx
import ChangePassword from "../../components/home/authComponents/ChangePassword";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ChangePassword />
    </HomeLayout>
  );
}
